module.exports = __webpack_public_path__ + "img/senior-user-join-btn-bg@2x.8fe42499.png";